var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#faq-page .faq-jumbotron-content{\n  background-image:url(" + escape(require("../../assets/images/pages/faq.jpg")) + ");\n  background-size:cover\n}\n#faq-page .faq-bg{\n  background-color:#fff\n}", ""]);

// exports
